module.exports = __webpack_public_path__ + "static/6-4bc93e2a299eb3c27ed665f3c69aed07.webp";